import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PasswordService } from '../services/PasswordService';

@Component({
    selector: 'user-change-password',
    template: require('./ChangePasswordComponent.html'),
    styles: [require('./ChangePasswordComponent.sass')],
})

export class ChangePasswordComponent implements OnInit {
    message: string;
    messageType: string;

    private redirectUrl = "booking/students";
    private formSubmitted: boolean = false;
    private oldPassword: string;
    private newPassword: string;
    private confirmNewPassword: string;
    private hostName: any;
    protected devEnv: any = ['services.eca.dev.nascorp.vn','camp.eca.dev.nascorp.vn', 'asa.eca.dev.nascorp.vn', 'holiday.eca.dev.nascorp.vn', 'bus.eca.dev.nascorp.vn'];
    protected testEnv: any = ['services.eca.test.nascorp.vn','camp.eca.test.nascorp.vn', 'asa.eca.test.nascorp.vn', 'holiday.eca.test.nascorp.vn', 'bus.eca.test.nascorp.vn'];
    protected stagingEnv: any = ['auth.eca.uat.nascorp.vn','services.eca.uat.nascorp.vn','asa.eca.uat.nascorp.vn','holidayschool.eca.uat.nascorp.vn','bus.eca.uat.nascorp.vn','outdooreducation.eca.uat.nascorp.vn','reen.eca.uat.nascorp.vn','acs.eca.uat.nascorp.vn','pcbs.eca.uat.nascorp.vn'];
    protected procEnv: any = ['services.aisvietnam.com','outdooreducation.aisvietnam.com', 'asa.aisvietnam.com', 'holidayschool.aisvietnam.com', 'bus.aisvietnam.com']
    
    constructor(
        private passwordService: PasswordService,
        private router: Router
    ) { }

    ngOnInit() {
        this.message = "";
        this.messageType = "";
        this.hostName = window.location.hostname;
        console.log(this.hostName)
    }

    onSubmit() {
        // Mark form as submitted to disable submit button
        this.formSubmitted = true;
        
        // Reset form alert message 
        this.message = "";
        this.messageType = "";

        this.changePassword(this.oldPassword, this.newPassword);
    }

    private changePassword(oldPassword:string, newPassword: string) {
        this.passwordService.setNewPassword(oldPassword, newPassword)
            .subscribe(
                complete => {
                    if(this.devEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = 'http://services.eca.dev.nascorp.vn/';
                    }
                    else if(this.testEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = 'http://services.eca.test.nascorp.vn/';
                    }
                    else if(this.stagingEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = 'http://services.eca.uat.nascorp.vn/';
                    }
                    else if(this.procEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = 'https://services.aisvietnam.com/';
                    }
                    else{
                        return window.location.href = 'http://services.local.eca.dev.nascorp.vn/';
                    }
                },
                error => {
                    this.message = "Invalid old password input.";
                    this.messageType = "alert";
                    this.formSubmitted = false;
                }
            )
    }

    private redirect(redirectUrl: string) {
        this.router.navigate([redirectUrl]);
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/user/change-password/ChangePasswordComponent.ts